import { FC } from "react";

import { RidesKanbanDragOrSelectHandleClone } from "./rides.kanban.drag-or-select-handle.clone";
import { RidesKanbanDragOrSelectHandleInteractive } from "./rides.kanban.drag-or-select-handle.interactive";
import { IRidesKanbanDragOrSelectHandle } from "./rides.kanban.drag-or-select-handle.models";

export type { IRidesKanbanDragOrSelectHandle } from "./rides.kanban.drag-or-select-handle.models";

export const RidesKanbanDragOrSelectHandle: FC<
  IRidesKanbanDragOrSelectHandle
> = ({ rideDto, isDragClone }) => {
  if (isDragClone) {
    return <RidesKanbanDragOrSelectHandleClone rideDto={rideDto} />;
  }

  return <RidesKanbanDragOrSelectHandleInteractive rideDto={rideDto} />;
};
